'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bluebird = require('bluebird');

var _lodash = require('lodash');

var _joi = require('../../services/joi');

var _joi2 = _interopRequireDefault(_joi);

var _FormLayout = require('./FormLayout');

var _FormLayout2 = _interopRequireDefault(_FormLayout);

var _FieldLayout = require('./FieldLayout');

var _FieldLayout2 = _interopRequireDefault(_FieldLayout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var INPUT_PREFIX = 'input-';

var DynamicFormContainer = function (_React$Component) {
  _inherits(DynamicFormContainer, _React$Component);

  function DynamicFormContainer(props) {
    _classCallCheck(this, DynamicFormContainer);

    var _this = _possibleConstructorReturn(this, (DynamicFormContainer.__proto__ || Object.getPrototypeOf(DynamicFormContainer)).call(this, props));

    _this.mounted = false;
    _this.state = _this.getDefaultState();
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.handleFieldChange = _this.handleFieldChange.bind(_this);
    _this.handleFieldBlur = _this.handleFieldBlur.bind(_this);
    _this.handleChange = _this.props.debounceMs ? (0, _lodash.debounce)(_this.handleChange.bind(_this), _this.props.debounceMs) : _this.handleChange.bind(_this);
    return _this;
  }

  _createClass(DynamicFormContainer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.mounted = true;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: 'getDefaultState',
    value: function getDefaultState() {
      var fields = this.props.fields;

      return {
        derivedFieldValues: {},
        submitting: false,
        input: fields.reduce(function (out, field) {
          return _extends({}, out, _defineProperty({}, field.id, field.defaultValue === undefined ? '' : field.defaultValue));
        }, {}),
        validationWarning: null
      };
    }

    /**
     * Handles the submit event
     */

  }, {
    key: 'handleSubmit',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee(e) {
        var input, onSubmit, data, result;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                e.preventDefault();
                e.stopPropagation();

                input = this.state.input;
                onSubmit = this.props.onSubmit;


                if (this.mounted) {
                  this.setState({ submitting: true });
                }

                _context.next = 7;
                return this.validate(input, true);

              case 7:
                data = _context.sent;

                if (!data) {
                  _context.next = 17;
                  break;
                }

                _context.prev = 9;
                _context.next = 12;
                return onSubmit(data);

              case 12:
                result = _context.sent;

                if (result && this.mounted) {
                  this.setState(this.getDefaultState());
                }

              case 14:
                _context.prev = 14;

                if (this.mounted) {
                  this.setState({ submitting: false });
                }
                return _context.finish(14);

              case 17:

                if (this.mounted) {
                  this.setState({ submitting: false });
                }

              case 18:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[9,, 14, 17]]);
      }));

      function handleSubmit(_x) {
        return _ref.apply(this, arguments);
      }

      return handleSubmit;
    }()

    /**
     * Handles a field changing
     */

  }, {
    key: 'handleFieldChange',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee2(field, value) {
        var _this2 = this;

        var fieldName;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                fieldName = field.substr(INPUT_PREFIX.length);
                _context2.next = 3;
                return new Promise(function (resolve) {
                  if (_this2.mounted) {
                    _this2.setState(function (state) {
                      return _extends({}, state, {
                        input: _extends({}, state.input, _defineProperty({}, fieldName, value))
                      });
                    }, resolve);
                  }
                });

              case 3:
                _context2.next = 5;
                return this.handleChange();

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handleFieldChange(_x2, _x3) {
        return _ref2.apply(this, arguments);
      }

      return handleFieldChange;
    }()
  }, {
    key: 'handleChange',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
        var _this3 = this;

        var _props, onChange, derivedFields, input, derivedFieldValues, invalidFields;

        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _props = this.props, onChange = _props.onChange, derivedFields = _props.derivedFields;
                input = this.state.input;
                _context3.next = 4;
                return (0, _bluebird.props)((0, _lodash.mapValues)(derivedFields, function (f) {
                  return f(input);
                }));

              case 4:
                derivedFieldValues = _context3.sent;
                _context3.next = 7;
                return new Promise(function (resolve) {
                  if (_this3.mounted) {
                    _this3.setState({
                      derivedFieldValues: derivedFieldValues
                    }, resolve);
                  } else {
                    resolve();
                  }
                });

              case 7:
                invalidFields = this.state.validationError ? this.state.validationError.details.reduce(function (out, item) {
                  return (0, _lodash.uniq)(out.concat([item.path.join('.')]));
                }, []) : [];


                onChange(_extends({}, (0, _lodash.mapValues)(this.state.input, function (value, key) {
                  return invalidFields.indexOf(key) === -1 ? value : null;
                }), this.state.derivedFieldValues));

              case 9:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function handleChange() {
        return _ref3.apply(this, arguments);
      }

      return handleChange;
    }()

    /**
     * Blurring any fields causes the form to re-validate
     */

  }, {
    key: 'handleFieldBlur',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
        var input;
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                input = this.state.input;
                _context4.next = 3;
                return this.validate(input);

              case 3:
                _context4.next = 5;
                return this.handleChange();

              case 5:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function handleFieldBlur() {
        return _ref4.apply(this, arguments);
      }

      return handleFieldBlur;
    }()

    /**
     * Validates some input
     *
     * @param {Object} input - current data being validated
     * @param {Boolean} submitting - if true, check all fields
     * @returns {Promise<Object | null>} data formatted to spec of joi validation rules if no errors.
     */

  }, {
    key: 'validate',
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee6(input) {
        var _this4 = this;

        var submitting = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        var _props2, validationRules, derivedFields, fields, result, warningMessages, validationWarning, derivedInput, checkErrors, validationError, details;

        return _regenerator2.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _props2 = this.props, validationRules = _props2.validationRules, derivedFields = _props2.derivedFields, fields = _props2.fields;
                result = _joi2.default.validate(input, validationRules, { stripUnknown: true, abortEarly: false });
                warningMessages = [];
                _context6.next = 5;
                return (0, _bluebird.each)(fields.filter(function (f) {
                  return f.warnings;
                }), function (field) {
                  return (0, _bluebird.each)(field.warnings, function (warning) {
                    var message = warning(input);
                    if (message) {
                      warningMessages.push({
                        path: field.id,
                        message: message
                      });
                    }
                  });
                });

              case 5:
                validationWarning = null;

                if (warningMessages.length) {
                  validationWarning = submitting ? { details: warningMessages } : {
                    details: warningMessages.filter(function (warning) {
                      return input[warning.path] !== '';
                    })
                  };
                }

                _context6.t0 = _extends;
                _context6.t1 = {};
                _context6.t2 = result.value;
                _context6.next = 12;
                return (0, _bluebird.props)((0, _lodash.mapValues)(derivedFields, function (f) {
                  return f(result.value);
                }));

              case 12:
                _context6.t3 = _context6.sent;
                derivedInput = (0, _context6.t0)(_context6.t1, _context6.t2, _context6.t3);
                checkErrors = [];
                _context6.next = 17;
                return (0, _bluebird.each)(fields.filter(function (f) {
                  return f.checks;
                }), function (field) {
                  return (0, _bluebird.each)(field.checks, function () {
                    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee5(check) {
                      return _regenerator2.default.wrap(function _callee5$(_context5) {
                        while (1) {
                          switch (_context5.prev = _context5.next) {
                            case 0:
                              _context5.prev = 0;
                              _context5.next = 3;
                              return check(derivedInput);

                            case 3:
                              _context5.next = 8;
                              break;

                            case 5:
                              _context5.prev = 5;
                              _context5.t0 = _context5['catch'](0);

                              checkErrors.push({
                                path: [field.id],
                                message: _context5.t0.message
                              });

                            case 8:
                            case 'end':
                              return _context5.stop();
                          }
                        }
                      }, _callee5, _this4, [[0, 5]]);
                    }));

                    return function (_x6) {
                      return _ref6.apply(this, arguments);
                    };
                  }());
                });

              case 17:
                validationError = null;
                // Merge the different errors.

                if (result.error || checkErrors.length) {
                  details = [].concat(_toConsumableArray(result.error ? result.error.details : []), _toConsumableArray(checkErrors.length ? checkErrors : []));

                  validationError = {
                    details: submitting ? details : details.filter(function (fieldError) {
                      return input[fieldError.path] !== '';
                    })
                  };
                }

                // Set state if we're mounted.
                if (this.mounted) {
                  this.setState({
                    validationError: validationError,
                    validationWarning: validationWarning
                  });
                }
                this.handleChange();
                // Return null if we had errors.
                return _context6.abrupt('return', validationError ? null : derivedInput);

              case 22:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function validate(_x5) {
        return _ref5.apply(this, arguments);
      }

      return validate;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var _state = this.state,
          input = _state.input,
          validationError = _state.validationError,
          validationWarning = _state.validationWarning,
          submitting = _state.submitting;
      var _props3 = this.props,
          children = _props3.children,
          disabled = _props3.disabled,
          FormComponent = _props3.formComponent,
          fields = _props3.fields,
          buttonClassName = _props3.buttonClassName,
          submitText = _props3.submitText,
          formClassName = _props3.formClassName,
          layoutOptions = _props3.layoutOptions;

      var errorsByField = validationError ? validationError.details.reduce(function (out, error) {
        return _extends({}, out, _defineProperty({}, error.path, (out[error.path] || []).concat([error])));
      }, {}) : {};
      var warningsByField = validationWarning ? validationWarning.details.reduce(function (out, warning) {
        return _extends({}, out, _defineProperty({}, warning.path, (out[warning.path] || []).concat([warning])));
      }, {}) : {};

      var fieldComponents = fields.map(function (fieldDefinition) {
        var InputComponent = fieldDefinition.inputComponent,
            options = fieldDefinition.inputOptions,
            required = fieldDefinition.required;


        var FieldComponent = fieldDefinition.fieldComponent || _FieldLayout2.default;
        var fieldOptions = fieldDefinition.fieldOptions || {};
        var inputId = '' + INPUT_PREFIX + fieldDefinition.id;
        var errors = (errorsByField[fieldDefinition.id] || []).map(function (error) {
          return error.message;
        });
        var warnings = (warningsByField[fieldDefinition.id] || []).map(function (warning) {
          return warning.message;
        });

        var inputName = (0, _lodash.kebabCase)(InputComponent.displayName || InputComponent.name || 'Unknown');

        return _react2.default.createElement(
          FieldComponent,
          _extends({
            id: fieldDefinition.id,
            key: fieldDefinition.id,
            label: fieldDefinition.label,
            inputId: inputId,
            required: required,
            errorMessages: errors,
            warningMessages: warnings,
            type: inputName
          }, fieldOptions, layoutOptions),
          _react2.default.createElement(InputComponent, _extends({
            id: inputId,
            onChange: _this5.handleFieldChange,
            onBlur: _this5.handleFieldBlur,
            value: input[fieldDefinition.id],
            valid: errors.length === 0
          }, options))
        );
      });

      return _react2.default.createElement(
        FormComponent,
        _extends({
          submitting: submitting,
          error: validationError,
          buttonClassName: buttonClassName,
          submitText: submitText,
          onSubmit: this.handleSubmit,
          onFieldChange: this.handleFieldChange,
          handleFieldBlur: this.handleFieldBlur,
          fieldComponents: fieldComponents,
          formClassName: formClassName,
          disabled: disabled || submitting
        }, layoutOptions),
        children
      );
    }
  }]);

  return DynamicFormContainer;
}(_react2.default.Component);

exports.default = DynamicFormContainer;


DynamicFormContainer.defaultProps = {
  formComponent: _FormLayout2.default,
  children: '',
  buttonClassName: 'btn',
  submitText: 'Submit',
  disabled: false,
  derivedFields: {},
  validationRules: _joi2.default.object({}),
  onChange: _lodash.noop,
  onSubmit: _lodash.noop,
  formClassName: '',
  debounceMs: 300,
  layoutOptions: {}
};

DynamicFormContainer.propTypes = {
  formComponent: _propTypes2.default.func,
  layoutOptions: _propTypes2.default.shape({}),
  onSubmit: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  validationRules: _propTypes2.default.shape({}),
  fields: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    label: _propTypes2.default.string,
    inputComponent: _propTypes2.default.func.isRequired,
    fieldComponent: _propTypes2.default.func,
    inputOptions: _propTypes2.default.shape({})
  })).isRequired,
  derivedFields: _propTypes2.default.objectOf(_propTypes2.default.func),
  children: _propTypes2.default.node,
  buttonClassName: _propTypes2.default.string,
  submitText: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  formClassName: _propTypes2.default.string,
  debounceMs: _propTypes2.default.number
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/components/form/DynamicFormContainer.js
// module id = 1110
// module chunks = 0